export const LINE_HEIGHTS: string[] = [
  '1', '1.2', '1.5', '1.6', '1.8', '2', '2.4', '2.8', '3'
];